fx.service( class FacebookService extends fx.Service
{
    constructor(model)
    {
        super();

		this.model = model.creationModel;

        this.data = this.model.facebook;

		this._init();
    }

	/*
	*
    *  // ------------- EXTRACTOR -------------- //
    *
    */

	_init()
	{
		if (!this._facebookExtractor)
		{
			this._facebookExtractor = new shared.extractors.FacebookExtractor({data : this.model});
			this.on("photo-extracted", this._onFacebookPhotoExtracted, this._facebookExtractor);
		}
	}

    _onFacebookPhotoExtracted(e)
	{
		// send pictures to MediaUpoloader so they can be stored on server
		fx.service("MediasUploader").upload(e.detail);
    }

    upload(selectedPhotos)
    {
		this._facebookExtractor.process(selectedPhotos);
    }

	addRawPhotos(datas)
	{
		let photos = [];
		for(let i = 0; i < datas.length; i++)
			photos.push(this._convertPhoto(datas[i]));

		this.upload(photos);
	}

    /*
	*
    *  // ------------- FACEBOOK SDK -------------- //
    *
    * Some browsers (mobile and desktop) block popups unless they are initiated by a user click.
    * So window.FB.login() function must be called only in response to the user's click
    *
    */
   
	initSDK()
	{
		this._initFacebookSDK();
	}

	login(callback)
    {
        if (this.fbUserId)
            this._getLoginStatus(callback);
        else
            this._userFbAuth(callback);
    }

    getAlbums()
    {
		this._getAlbums();
    }

    getPhotos(album)
    {
        this._getPhotos(album);
    }

	get nextAlbums()
	{
		return this._nextAlbums || null;
	}

	set nextAlbums(val)
	{
		this._nextAlbums = val;
	}

	// ------------------------ GET FACEBOOK SKD  ------------------------ //

    _initFacebookSDK()
	{
		this.albums = [];
		
		this._importFacebookSDK();
	}
	
	_importFacebookSDK()
	{
		if(!window.FB)
		{
			this.xhr = $.getScript('//connect.facebook.net/en_US/sdk.js', function() {
                window.FB.init({
                    appId      : '672815376111408',
                    xfbml      : false,
					version    : 'v8.0'
				});

            });
		}
	}

    // ------------------------ LOGIN  ------------------------ //
	
	_getLoginStatus(callback)
	{
		window.FB.getLoginStatus(response => {

			if(response.status === "connected")
				this._loginCallback(callback);
			else
				fx.log.info('User not fully authorize.');
		});
	}

	_userFbAuth(callback)
	{
		if (!window.FB)
			callback({error : true});
		else
			window.FB.login(response => {
			if (response.authResponse)
			{
				this.fbUserId = response.authResponse.userID;
				this._loginCallback(callback);
			}
			else
			{
				fx.log.info('User cancelled login or did not fully authorize.');
				callback({error : true});
			}

		}, { scope: 'email,user_photos' });
	}

	_loginCallback(callback)
	{
		if (!this.data.length)
			this._getAlbums();

		callback();

		if(window.fx.browser.isMobile || window.fx.browser.isTablet)
			this.data.event("show-facebook-albums");
		else
			this.data.event("show-facebook-photos");
	}

	// ------------------------ GET ALBUMS  ------------------------ //

    _getAlbums()
	{
		let url = '/me?fields=albums.limit(12){name,count,cover_photo{picture}}';

		if (this.nextAlbums)
			url = this.nextAlbums;

		window.FB.api(url, response => {
			if (response.albums)
			{
				if (response.albums.paging.next)
					this.nextAlbums = response.albums.paging.next;
				
				this._getAlbumsCoverphotos(0, response.albums.data);

			}

			// next url has another response object	
			else if (response.data)
			{
				if (response.paging.next)
					this.nextAlbums = response.paging.next;
				else
					this.nextAlbums = null;

				this._getAlbumsCoverphotos(0, response.data);
			}
		});
	}

	_getAlbumsCoverphotos(index, albumsData)
    {
		if (index === 0 && albumsData.length > 0)
			this.albums = albumsData;

        else
        {
            if (index >= this.albums.length)
            {
				this._addAlbums(this.albums);
				this.albums = [];
                return;
            }
        }

        let album = this.albums[index];

        window.FB.api("/" + album.id + "/picture", {"redirect":false,"type":"album"}, (response) => {
			if (!response || response.error)
				fx.log.error( response.error );
			else
				album.cover_url = response.data.url;

            this._getAlbumsCoverphotos( ++index);
        });
    }

	_addAlbums(albums)
	{
		this.data.albumsLazyLoadingActive = 0;
		
		for (let i = 0; i < albums.length; i++)
		{
			if (!albums[i].count) continue;
			this.data.addAlbum(this._convertAlbum(albums[i]));
		}

		if (this.data.getItemAt(0))
		{
			if (!(window.fx.browser.isMobile || window.fx.browser.isTablet))
				this._getPhotos(this.data.getItemAt(0));
		}
	}

	_convertAlbum(facebookAlbum)
	{
		let album = {};

		album.id = facebookAlbum.id;
		album.name = facebookAlbum.name;
		album.count = facebookAlbum.count;
		album.cover_url = facebookAlbum.cover_url;
		album.photos = [];
		album.nextPhotos = null;
		album.isLoaded = false;
		album.isActive = this.data.length ? false : true;
		return album;
	}
	
	// ------------------------ GET PHOTOS  ------------------------ //

	_getPhotos(album)
	{
		let url = `/${album.id}/?fields=photos.limit(70){id,height,images,picture,width,name}`;
		
		if (album.nextPhotos)
			url = album.nextPhotos;

		window.FB.api(url, response => {

			if (response.photos && response.photos.data.length > 0) 
				this._addPhotos(response.photos, album);

			// next url has another response object	
			if (response.data && response.data.length > 0) 
				this._addPhotos(response, album);
		})

	}

	_addPhotos(photosData, album)
	{
		this.data.lazyLoadingActive = 0;

		let photos = photosData.data;

		for (let i = 0; i < photos.length; i++)
		{
			this.data.addPhoto(album, this._convertPhoto(photos[i]));
		}

		if (photosData.paging.next)
			album.nextPhotos = photosData.paging.next;
		else
		{
			album.isLoaded = true;
			album.nextPhotos = null;
		}

		this.trigger("photos-loaded");
	}

	_convertPhoto(rawPhoto)
	{
		let photo = {};

		let minWidth, maxWidth, thumb, origin_url;

		rawPhoto.images.forEach( img => {
			if (!minWidth || img.width < minWidth)
			{
				minWidth = img.width;
				thumb = img.source;
			}

			if (!maxWidth || img.width > maxWidth)
			{
				maxWidth = img.width;
				origin_url = img.source
			}
		});

		photo.id = rawPhoto.id;
		photo.thumb = thumb;
		photo.origin_url = origin_url;

		return photo;
	}

});